/** Scent pill UI for the PDP buy box; each click drives the hidden native variant-picker radio. */
import { nextPill } from '@theme/ca-variant-pills';

(function () {
  if (window.__caScentPickerInit) return;
  window.__caScentPickerInit = true;

  function cssEscape(value) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
    return String(value).replace(/["\\\]#.:]/g, '\\$&');
  }

  function initPicker(root) {
    if (!root || root.dataset.caScentReady === 'true') return;
    root.dataset.caScentReady = 'true';

    var pillWrap = root.querySelector('[data-ca-scent-pills]');
    if (!pillWrap) return;

    var nameEl = root.querySelector('[data-ca-scent-name]');
    var noteEl = root.querySelector('[data-ca-scent-note]');
    var liveEl = root.querySelector('[data-ca-scent-live]');
    var nativePicker = root.querySelector('variant-picker');

    if (nativePicker) {
      var natInputs = nativePicker.querySelectorAll('input, select, [tabindex]');
      for (var n = 0; n < natInputs.length; n++) natInputs[n].setAttribute('tabindex', '-1');
    }

    var warmed = Object.create(null);
    /** @type {Record<string, Document>} parsed section documents, keyed by option value id */
    var warmedDocs = Object.create(null);

    function sectionUrlFor(pill) {
      var base = nativePicker && nativePicker.dataset.productUrl;
      var ovid = pill.dataset.optionValueId;
      if (!base || !ovid) return null;
      var url = base.split('?')[0] + '?option_values=' + encodeURIComponent(ovid);

      var sectionId = nativePicker.dataset.sectionId;
      if (sectionId) url += '&section_id=' + encodeURIComponent(sectionId);
      return url;
    }

    /** How many pills to warm up front (a data budget; hover/focus covers the rest). */
    function eagerWarmBudget(total) {
      var c = navigator.connection;
      if (c) {
        if (c.saveData) return 0;
        var t = c.effectiveType || '';
        if (/(^|-)(2g|3g)$/.test(t)) return 0;
      }
      return total <= 6 ? total : 8;
    }

    function warm(pill) {
      if (!pill) return;
      if (pill.classList.contains('on')) return;
      var ovid = pill.dataset.optionValueId;
      if (!ovid || warmed[ovid] || !pill.dataset.variantId) return;
      var url = sectionUrlFor(pill);
      if (!url) return;
      warmed[ovid] = true;

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : null;
        })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var img = doc.querySelector('media-gallery img.product-media__image');
          if (img) {
            var preload = new Image();
            // sizes before srcset, or the candidate is picked against 100vw
            if (img.getAttribute('sizes')) preload.sizes = img.getAttribute('sizes');
            if (img.getAttribute('srcset')) preload.srcset = img.getAttribute('srcset');
            if (img.getAttribute('src')) preload.src = img.getAttribute('src');
          }
          warmedDocs[ovid] = doc;
        })
        .catch(function () {
          warmed[ovid] = false;
        });
    }

    /** The gallery's lead image: the tile that shows the selected variant's photo. */
    function leadGalleryImage() {
      return document.querySelector(
        'media-gallery ul:not(.dialog-zoomed-gallery) img.product-media__image'
      );
    }

    /** Preload a variant's photo from the URLs Liquid put on the pill. */
    function preloadPillImage(pill) {
      if (!pill || pill.dataset.caImgPreloaded === 'true') return;
      var srcset = pill.dataset.mediaSrcset;
      if (!srcset) return;
      pill.dataset.caImgPreloaded = 'true';
      var lead = leadGalleryImage();
      var pre = new Image();
      if (lead && lead.getAttribute('sizes')) pre.sizes = lead.getAttribute('sizes');
      pre.srcset = srcset;
      if (pill.dataset.mediaSrc) pre.src = pill.dataset.mediaSrc;
    }

    /** Repaint just the gallery's lead image from the pill's own URLs (no fetch). */
    function paintLeadImageFromPill(pill) {
      var srcset = pill && pill.dataset.mediaSrcset;
      if (!srcset) return false;
      var lead = leadGalleryImage();
      if (!lead) return false;
      lead.srcset = srcset;
      if (pill.dataset.mediaSrc) lead.src = pill.dataset.mediaSrc;
      lead.removeAttribute('data_max_resolution');
      return true;
    }

    /** Paint the gallery for `ovid` from the warmed document; true if a gallery was swapped. */
    function paintGalleryFromCache(ovid, variantId) {
      var doc = warmedDocs[ovid];
      if (!doc) return false;

      var galleries = document.querySelectorAll('media-gallery');
      var swapped = false;

      for (var i = 0; i < galleries.length; i++) {
        var gallery = galleries[i];
        var match = gallery.id ? doc.querySelector('#' + cssEscape(gallery.id)) : null;
        var allowFirstMatchFallback = !gallery.classList.contains('media-gallery--full-bleed');
        var replacement = match || (allowFirstMatchFallback ? doc.querySelector('media-gallery') : null);
        if (!replacement) continue;

        // Clone, never adopt: adopting strips the gallery out of the cached doc.
        var fresh = replacement.cloneNode(true);

        if (variantId) fresh.setAttribute('data-ca-optimistic', String(variantId));

        gallery.replaceWith(fresh);
        swapped = true;
      }
      return swapped;
    }

    pillWrap.addEventListener('pointerover', function (event) {
      var pill = event.target.closest && event.target.closest('.ca-pill');
      if (pill) warm(pill);
    });

    pillWrap.addEventListener('focusin', function (event) {
      var pill = event.target.closest && event.target.closest('.ca-pill');
      if (pill) warm(pill);
    });

    function warmAtIdle() {
      var all = Array.prototype.slice.call(pillWrap.querySelectorAll('.ca-pill'));

      var conn = navigator.connection;
      var thrifty = !!(conn && (conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '')));
      if (!thrifty) {
        for (var p = 0; p < all.length; p++) preloadPillImage(all[p]);
      }

      var budget = eagerWarmBudget(all.length);
      if (!budget) return;
      var pending = all.slice(0, budget);
      (function next() {
        var pill = pending.shift();
        if (!pill) return;
        warm(pill);
        setTimeout(next, 150);
      })();
    }

    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(warmAtIdle, { timeout: 1500 });
    } else {
      setTimeout(warmAtIdle, 800);
    }

    function paint(pill) {
      if (nameEl) nameEl.textContent = pill ? '— ' + (pill.dataset.title || '') : '';
      if (noteEl) noteEl.textContent = pill ? pill.dataset.scentNote || '' : '';
    }

    function setActive(pill, moveFocus) {
      var pills = pillWrap.querySelectorAll('.ca-pill');
      for (var i = 0; i < pills.length; i++) {
        var on = pills[i] === pill;
        pills[i].classList.toggle('on', on);
        pills[i].setAttribute('aria-checked', on ? 'true' : 'false');
        pills[i].setAttribute('tabindex', on ? '0' : '-1');
      }
      paint(pill);
      if (moveFocus && pill) pill.focus();
      if (liveEl && pill) liveEl.textContent = pill.dataset.scentNote || '';
    }

    pillWrap.addEventListener('keydown', function (event) {
      // Sold-out pills stay reachable (selecting one opens the back-in-stock form); only hard-disabled ones are skipped.
      var pills = Array.prototype.slice.call(pillWrap.querySelectorAll('.ca-pill')).filter(function (p) {
        return !p.disabled;
      });
      var next = nextPill(event.key, pills, pillWrap.querySelector('.ca-pill.on') || pills[0]);
      if (!next) return;
      event.preventDefault();
      next.click();
      next.focus();
    });

    pillWrap.addEventListener('click', function (event) {
      // Sold-out pills are not rejected here; only a hard-disabled button is ignored.
      var pill = event.target.closest('.ca-pill');
      if (!pill || pill.disabled) return;

      var ovid = pill.dataset.optionValueId;
      var input = nativePicker && ovid
        ? nativePicker.querySelector('input[data-option-value-id="' + cssEscape(ovid) + '"]')
        : null;

      if (input) {
        setActive(pill);

        if (!paintGalleryFromCache(ovid, pill.dataset.variantId)) {
          paintLeadImageFromPill(pill);
        }

        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Combined listing: navigate; never paint the pill active (no variant:update to reconcile it).
      if (pill.dataset.url) window.location.href = pill.dataset.url;
    });

    var scope = root.closest('.shopify-section') || document;
    scope.addEventListener('variant:update', function (event) {
      var resource = event.detail && event.detail.resource;
      var vid = resource && resource.id;
      if (vid == null) return;
      var pill = pillWrap.querySelector(
        '.ca-pill[data-variant-id="' + cssEscape(String(vid)) + '"]'
      );
      if (pill) setActive(pill);
    });

    var allPills = pillWrap.querySelectorAll('.ca-pill');
    if (allPills.length) {
      var entry = pillWrap.querySelector('.ca-pill.on') || allPills[0];
      for (var p = 0; p < allPills.length; p++) {
        allPills[p].setAttribute('tabindex', allPills[p] === entry ? '0' : '-1');
      }
    }
  }

  function initAll(context) {
    var roots = (context || document).querySelectorAll('[data-ca-scent-picker]');
    for (var i = 0; i < roots.length; i++) initPicker(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
